import { ProductCard } from './ProductCard';
import { Product } from '../../types/Products/Products';

type SelectedProductProps = {
  product: Product;
  selected: string;
};
export const SelectedProduct = (props: SelectedProductProps) => {
  return <ProductCard product={props.product} selected={props.selected} />;
};
